import { Image } from "./image";
import React from "react";

export const Gallery = (props) => {
  // Function to split the data into chunks of 3 items per slide
  const chunkData = (data, chunkSize) => {
    let result = [];
    for (let i = 0; i < data.length; i += chunkSize) {
      result.push(data.slice(i, i + chunkSize));
    }
    return result;
  };

  return (
    <div id="portfolio" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>{props?.data?.title}</h2>
        </div>
        <div className="row">
          <div id="portfolioCarousel" className="carousel slide" data-ride="carousel">
            {/* Indicators */}
            <ol className="carousel-indicators">
              {props.data?.list
                ? chunkData(props?.data?.list, 3).map((_, i) => (
                    <li
                      key={i}
                      data-target="#portfolioCarousel"
                      data-slide-to={i}
                      className={i === 0 ? "active" : ""}
                    ></li>
                  ))
                : null}
            </ol>

            {/* Carousel Items */}
            <div className="carousel-inner">
              {props.data?.list
                ? chunkData(props?.data?.list, 3).map((chunk, i) => (
                    <div
                      key={`chunk-${i}`}
                      className={`item ${i === 0 ? "active" : ""}`}
                    >
                      <div className="row">
                        {chunk.map((d, j) => (
                          <div key={`${d.title}-${j}`} className="col-md-4">
                            <div className="carousel-image">
                              <Image
                                title={d.title}
                                largeImage={d.largeImage}
                                smallImage={d.smallImage}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))
                : "Loading..."}
            </div>

            
            <a
              className="left carousel-control"
              href="#portfolioCarousel"
              data-slide="prev"
              style={{display:'flex', justifyContent:'center', alignItems: 'center'}}
            >
              <i className="fa-solid fa-arrow-left"></i>
              <span className="sr-only">Previous</span>
            </a>
            <a
              className="right carousel-control"
              href="#portfolioCarousel"
              data-slide="next"
              style={{display:'flex', justifyContent:'center', alignItems: 'center'}}
            >
              <i className="fa-solid fa-arrow-right"></i>
              <span className="sr-only">Next</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
